import createLucideIcon from '../createLucideIcon';

const AlertTriangle = createLucideIcon('AlertTriangle', [
  [
    'path',
    {
      d: 'm21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z',
      key: 'c3ski4',
    },
  ],
  ['line', { x1: '12', x2: '12', y1: '9', y2: '13', key: '1gkch0' }],
  ['line', { x1: '12', x2: '12.01', y1: '17', y2: '17', key: 'io3f8k' }],
]);

export default AlertTriangle;
